import { FormGroup } from '@angular/forms';

export function markAllAsDirty(formGroup: FormGroup): void {
  if (!formGroup || !formGroup.controls) {
    return;
  }

  for (const control of Object.values(formGroup.controls)) {
    if (control instanceof FormGroup) {
      markAllAsDirty(control as FormGroup);
    } else {
      // mark as dirty
      control.markAsDirty();
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }
}
